<template>
  <div class="scroller">
    <div class="scroller__gradient scroller__gradient--left" v-if="canScrollLeft"></div>
    <div
      class="scroller__arrow scroller__arrow--left"
      v-show="canScrollLeft"
      @mouseenter="startScroll('left')"
      @mouseleave="stopScroll"
    >
      <ArrowTiny class="scroller__arrow-icon" />
    </div>
    <div class="scroller__container" ref="container" @scroll="updateScrollState">
      <slot />
    </div>
    <div
      class="scroller__arrow scroller__arrow--right"
      v-show="canScrollRight"
      @mouseenter="startScroll('right')"
      @mouseleave="stopScroll"
    >
      <ArrowTiny class="scroller__arrow-icon" />
    </div>
    <div class="scroller__gradient scroller__gradient--right" v-if="canScrollRight"></div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
  //---------------------------------------------
  import ArrowTiny from '@svg/ArrowTiny.vue';
  //---------------------------------------------
  const container = ref(null);
  const scrollInterval = ref(null);
  const canScrollLeft = ref(false);
  const canScrollRight = ref(false);
  //---------------------------------------------
  const SCROLL_STEP = 30;
  //---------------------------------------------
  onMounted(async () => {
    await nextTick();
    updateScrollState();
    window.addEventListener('resize', updateScrollState);
  });
  onBeforeUnmount(() => {
    stopScroll();
    window.removeEventListener('resize', updateScrollState);
  });
  //---------------------------------------------
  //Обновляет флаги скролла: можно ли прокручивать влево или вправо
  const updateScrollState = () => {
    const el = container.value;
    if (!el) return;
    canScrollLeft.value = el.scrollLeft > 0;
    canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  };
  //Запускает автоматическую прокрутку в указанную сторону при наведении
  const startScroll = (direction) => {
    console.log('startScroll triggered', direction);
    stopScroll();
    container.value?.scrollBy({ left: direction === 'left' ? -SCROLL_STEP : SCROLL_STEP });
    updateScrollState(); // сразу после первого шага
    scrollInterval.value = setInterval(() => {
      container.value?.scrollBy({ left: direction === 'left' ? -SCROLL_STEP : SCROLL_STEP });
      updateScrollState();
    }, 100);
  };
  //Останавливает автоматическую прокрутку
  const stopScroll = () => {
    if (scrollInterval.value) {
      clearInterval(scrollInterval.value);
      scrollInterval.value = null;
    }
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>